import { AxiosResponse } from 'axios';
import SeekerConnection from 'wwg-utilities/dist/collections/seeker-connection';
import auth from '../config/firebase';
import { getCookie } from '../cookies';
import apiClient from './axiosClient';

const getTrainingConnectionRequest = async (
  userId: string = '',
  programId: string = '',
): Promise<SeekerConnection> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');
  return apiClient
    .get(`seeker-connections/${userId}/${programId}`, {
      headers: {
        'Authorization-WWG': `Bearer ${token}`,
      },
    })
    .then((res: AxiosResponse) => res.data);
};

export default getTrainingConnectionRequest;
